const text_test_frag = `#version 300 es
uniform highp vec3 custom_e914e45bb5c56267;
uniform highp float custom_905c3f97a4912a69;
uniform highp float custom_70423549a8529160[4];
uniform highp vec4 custom_1f66b3243e102e24;
uniform highp vec4 custom_eece0e40dafb39c6;
uniform highp float custom_77756f64d745704e;
uniform highp vec3 custom_c2308a19d7a17a82[4];
uniform highp int custom_2c04bf2ac4be0f31;
uniform highp float custom_851413965f0606e7;
uniform highp float custom_1c91913b763d547c;
uniform lowp sampler2D custom_ceb2d6eea8801718;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_6701f1729fb5bda4;
uniform lowp sampler2D custom_167041ad3f01be39;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_cebd318f3528d25a;
uniform lowp sampler2D custom_43ccb34651cbffe8;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_b6662b624451f6aa;
uniform lowp sampler2D custom_7fbae08bfdefee49;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_9cd5d8f2ade25989;
void custom_f473b6d23ddb8775(out highp vec4 custom_e30b609a99317854, in highp vec2 custom_af11434e7e975b00);
out highp vec4 custom_3e7e5c94b10cd58f;
void main(){
  (custom_3e7e5c94b10cd58f = vec4(0.0, 0.0, 0.0, 0.0));
  (custom_3e7e5c94b10cd58f = vec4(1.0, 1.0, 1.0, 1.0));
  highp vec4 custom_54d478077cd5722c = vec4(100000002004087734272.0, 100000002004087734272.0, 100000002004087734272.0, 100000002004087734272.0);
  custom_f473b6d23ddb8775(custom_54d478077cd5722c, gl_FragCoord.xy);
  if ((custom_3e7e5c94b10cd58f.x < 0.0))
  {
    (custom_54d478077cd5722c = vec4(1.0, 0.0, 0.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.y < 0.0))
  {
    (custom_54d478077cd5722c = vec4(0.0, 1.0, 0.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.z < 0.0))
  {
    (custom_54d478077cd5722c = vec4(0.0, 0.0, 1.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.w < 0.0))
  {
    (custom_54d478077cd5722c = vec4(1.0, 1.0, 0.0, 1.0));
  }
  const highp float s169a = 1.0;
  (custom_3e7e5c94b10cd58f = vec4(custom_54d478077cd5722c.xyz, s169a));
}
highp int custom_ebff057bd64d779a = 0;
highp vec4 custom_d54fe95c9ab244cf = vec4(0.0, 0.0, 0.0, 0.0);
highp vec4 custom_7b3751d326eb808c = vec4(12408.0, 7895088.0, 3145776.0, 3145728.0);
highp vec4 custom_7348919f367798cb = vec4(0.0, 0.0, 56.0, 3694592.0);
highp vec4 custom_46e7b1fb9f014b62 = vec4(2.0, 396312.0, 3170496.0, 8388608.0);
highp vec4 custom_a178d10e49707841 = vec4(31942.0, 14079702.0, 14079686.0, 8126464.0);
highp vec4 custom_b54e2ff05bfd5076 = vec4(4144.0, 15740976.0, 3158064.0, 16515072.0);
highp vec4 custom_68bfc0c90c7326c = vec4(30924.0, 13372440.0, 3170508.0, 16515072.0);
highp vec4 custom_c1f3613eea42c739 = vec4(30924.0, 789560.0, 789708.0, 7864320.0);
highp vec4 custom_a5dc081583dee148 = vec4(3100.0, 3960012.0, 16649228.0, 1966080.0);
highp vec4 custom_51f9ebca1f9ad4da = vec4(64704.0, 12632312.0, 789708.0, 7864320.0);
highp vec4 custom_10e7cdd4c453e1e9 = vec4(14432.0, 12632312.0, 13421772.0, 7864320.0);
highp vec4 custom_656b883fa3b7e37f = vec4(65222.0, 12977676.0, 1585200.0, 3145728.0);
highp vec4 custom_954be5515d6e37b4 = vec4(30924.0, 13429880.0, 14470348.0, 7864320.0);
highp vec4 custom_67145985756bcf25 = vec4(30924.0, 13421692.0, 1579056.0, 7340032.0);
highp vec4 custom_107cb01e133f919d = vec4(0.0, 3684352.0, 14392.0, 0.0);
highp vec4 custom_c18b2bedf156539f = vec4(63596.0, 6710886.0, 6710892.0, 16252928.0);
highp vec4 custom_a798d3ca0af99044 = vec4(52428.0, 13421820.0, 13421772.0, 13369344.0);
highp vec4 custom_a25a1289840af282 = vec4(64614.0, 6710908.0, 7104102.0, 15073280.0);
highp vec4 custom_dca27d8cadefa787 = vec4(64692.0, 3158064.0, 3158064.0, 7864320.0);
highp vec4 custom_1d29206f64f3c03a = vec4(0.0, 30732.0, 8178892.0, 7733248.0);
highp vec4 custom_c7151432b3f3bbfe = vec4(0.0, 30924.0, 12632268.0, 7864320.0);
highp vec4 custom_8c32636550787def = vec4(0.0, 30924.0, 16564428.0, 7864320.0);
highp vec4 custom_9be6abcb1efc6209 = vec4(57440.0, 6319222.0, 6710886.0, 15073280.0);
highp vec4 custom_7fa56cb12c591713 = vec4(6168.0, 30744.0, 1579032.0, 8257536.0);
highp vec4 custom_a09e692c9aea15a5 = vec4(30744.0, 1579032.0, 1579032.0, 8257536.0);
highp vec4 custom_928d9e40d21f2dd4 = vec4(0.0, 64726.0, 14079702.0, 12976128.0);
highp vec4 custom_42a613670c3674b1 = vec4(0.0, 63692.0, 13421772.0, 13369344.0);
highp vec4 custom_1a8a126282b27db9 = vec4(0.0, 30924.0, 13421772.0, 7864320.0);
highp vec4 custom_767e28934b6a271e = vec4(0.0, 60526.0, 7757920.0, 15728640.0);
highp vec4 custom_3af7b7d4ab96c0e = vec4(0.0, 30924.0, 6297804.0, 7864320.0);
highp vec4 custom_43e44ce01f171d64 = vec4(32.0, 6356064.0, 6316140.0, 3670016.0);
highp vec4 custom_befd9464d1662f38 = vec4(0.0, 52428.0, 13421772.0, 7733248.0);
highp vec4 custom_8d38c3c8aac5a084 = vec4(0.0, 50796.0, 3684460.0, 12976128.0);
highp vec2 custom_3fbe9df714044829 = vec2(0.0, 0.0);
highp vec2 custom_dc3b6638b4b7cf50 = vec2(0.0, 0.0);
highp float custom_dbe190b6fcaa4a8(in highp float custom_f9ace9bd2f6f65c5, in highp float custom_7bcad206d9cd79a4){
  (custom_7bcad206d9cd79a4 = clamp(custom_7bcad206d9cd79a4, -1.0, 24.0));
  return floor(mod(floor((custom_f9ace9bd2f6f65c5 / pow(2.0, floor(custom_7bcad206d9cd79a4)))), 2.0));
}
highp float custom_3afb10661115409b(in highp vec4 custom_bb172ca658352d2f, in highp vec2 custom_8f50b876e5f5c0a1, in highp vec2 custom_c82ec2f59ceb854e){
  (custom_c82ec2f59ceb854e = floor(custom_c82ec2f59ceb854e));
  const highp float s169b = 1.0;
  highp float custom_afa7b128ddf23a75 = (((custom_8f50b876e5f5c0a1.x - custom_c82ec2f59ceb854e.x) - s169b) + (custom_c82ec2f59ceb854e.y * custom_8f50b876e5f5c0a1.x));
  bool custom_d31be7aea7a181e6 = (all(greaterThanEqual(custom_c82ec2f59ceb854e, vec2(0.0, 0.0))) && all(lessThan(custom_c82ec2f59ceb854e, custom_8f50b876e5f5c0a1)));
  highp float custom_aa3d610ae99bd077 = 0.0;
  const highp float s169c = 72.0;
  (custom_aa3d610ae99bd077 += custom_dbe190b6fcaa4a8(custom_bb172ca658352d2f.x, (custom_afa7b128ddf23a75 - s169c)));
  const highp float s169d = 48.0;
  (custom_aa3d610ae99bd077 += custom_dbe190b6fcaa4a8(custom_bb172ca658352d2f.y, (custom_afa7b128ddf23a75 - s169d)));
  const highp float s169e = 24.0;
  (custom_aa3d610ae99bd077 += custom_dbe190b6fcaa4a8(custom_bb172ca658352d2f.z, (custom_afa7b128ddf23a75 - s169e)));
  const highp float s169f = 0.0;
  (custom_aa3d610ae99bd077 += custom_dbe190b6fcaa4a8(custom_bb172ca658352d2f.w, (custom_afa7b128ddf23a75 - s169f)));
  const highp float s16a0 = 0.0;
  return ((custom_d31be7aea7a181e6) ? (custom_aa3d610ae99bd077) : (s16a0));
}
highp float custom_41d06a1f7c3b87d9(in highp vec4 custom_cc2de5b5698e500c, in highp vec2 custom_c82ec2f59ceb854e){
  if ((custom_ebff057bd64d779a == 1))
  {
    const highp float s16a1 = 16777215.0;
    (custom_cc2de5b5698e500c = (s16a1 - custom_cc2de5b5698e500c));
  }
  if ((custom_ebff057bd64d779a == 2))
  {
    const highp float s16a2 = 256.0;
    const highp float s16a3 = 256.0;
    const highp float s16a4 = 255.0;
    (custom_cc2de5b5698e500c.w = ((floor((custom_cc2de5b5698e500c.w / s16a2)) * s16a3) + s16a4));
  }
  highp float custom_64960f6e962024f1 = custom_3afb10661115409b(custom_cc2de5b5698e500c, vec2(8.0, 12.0), (custom_c82ec2f59ceb854e - custom_dc3b6638b4b7cf50));
  const highp float s16a5 = 8.0;
  (custom_dc3b6638b4b7cf50.x += s16a5);
  return custom_64960f6e962024f1;
}
highp vec4 custom_c77c34d8dc0393d5(in highp float custom_fa6ee8ecaada3b41){
  (custom_fa6ee8ecaada3b41 = floor(custom_fa6ee8ecaada3b41));
  if ((custom_fa6ee8ecaada3b41 == 0.0))
  {
    return custom_a178d10e49707841;
  }
  if ((custom_fa6ee8ecaada3b41 == 1.0))
  {
    return custom_b54e2ff05bfd5076;
  }
  if ((custom_fa6ee8ecaada3b41 == 2.0))
  {
    return custom_68bfc0c90c7326c;
  }
  if ((custom_fa6ee8ecaada3b41 == 3.0))
  {
    return custom_c1f3613eea42c739;
  }
  if ((custom_fa6ee8ecaada3b41 == 4.0))
  {
    return custom_a5dc081583dee148;
  }
  if ((custom_fa6ee8ecaada3b41 == 5.0))
  {
    return custom_51f9ebca1f9ad4da;
  }
  if ((custom_fa6ee8ecaada3b41 == 6.0))
  {
    return custom_10e7cdd4c453e1e9;
  }
  if ((custom_fa6ee8ecaada3b41 == 7.0))
  {
    return custom_656b883fa3b7e37f;
  }
  if ((custom_fa6ee8ecaada3b41 == 8.0))
  {
    return custom_954be5515d6e37b4;
  }
  if ((custom_fa6ee8ecaada3b41 == 9.0))
  {
    return custom_67145985756bcf25;
  }
  return vec4(0.0, 0.0, 0.0, 0.0);
}
highp float custom_32186bc26d62d4d7(in highp float custom_134ccf470a2f5d11, in highp int custom_29238a2e325a2d72, in highp vec2 custom_c82ec2f59ceb854e){
  highp float custom_6aa1e4d387212513 = 0.0;
  for (highp int custom_441e866d43abd7e9 = 4; (custom_441e866d43abd7e9 >= 0); (custom_441e866d43abd7e9--))
  {
    highp float custom_3e61af91bb2a6423 = mod((custom_134ccf470a2f5d11 / pow(10.0, float(custom_441e866d43abd7e9))), 10.0);
    if ((((abs(custom_134ccf470a2f5d11) > pow(10.0, float(custom_441e866d43abd7e9))) || (custom_29238a2e325a2d72 > custom_441e866d43abd7e9)) || (custom_441e866d43abd7e9 == 0)))
    {
      (custom_6aa1e4d387212513 += custom_41d06a1f7c3b87d9(custom_c77c34d8dc0393d5(custom_3e61af91bb2a6423), custom_c82ec2f59ceb854e));
    }
  }
  return custom_6aa1e4d387212513;
}
highp float custom_25b98a04c46d8d37(in highp vec2 custom_c82ec2f59ceb854e){
  highp float custom_5a71a30409cd6bd6 = 0.0;
  const highp float s16a6 = 2.0;
  highp vec2 custom_3e18ff67d7afeadd = (custom_3fbe9df714044829 / s16a6);
  const highp float s16a7 = 60.0;
  const highp float s16a8 = 60.0;
  highp float custom_77b6ff4fa4f14048 = floor(((custom_eece0e40dafb39c6.w / s16a7) / s16a8));
  const highp float s16a9 = 60.0;
  highp float custom_d976b1da5776fe67 = floor(mod((custom_eece0e40dafb39c6.w / s16a9), 60.0));
  highp float custom_8b0a5e20e6d5d1c8 = floor(mod(custom_eece0e40dafb39c6.w, 60.0));
  const highp vec2 s16aa = vec2(68.0, 6.0);
  (custom_dc3b6638b4b7cf50 = floor((custom_3e18ff67d7afeadd - s16aa)));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_a798d3ca0af99044, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_8c32636550787def, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_a09e692c9aea15a5, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_a09e692c9aea15a5, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_1a8a126282b27db9, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_7348919f367798cb, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_d54fe95c9ab244cf, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_c18b2bedf156539f, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_1d29206f64f3c03a, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_a09e692c9aea15a5, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_7fa56cb12c591713, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_c7151432b3f3bbfe, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_9be6abcb1efc6209, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_767e28934b6a271e, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_1a8a126282b27db9, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_928d9e40d21f2dd4, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_8c32636550787def, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_7b3751d326eb808c, custom_c82ec2f59ceb854e));
  (custom_dc3b6638b4b7cf50 = vec2(2.0, 26.0));
  (custom_ebff057bd64d779a = 1);
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_c18b2bedf156539f, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_1d29206f64f3c03a, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_43e44ce01f171d64, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_8c32636550787def, custom_c82ec2f59ceb854e));
  (custom_ebff057bd64d779a = 0);
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_107cb01e133f919d, custom_c82ec2f59ceb854e));
  (custom_ebff057bd64d779a = 2);
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7(custom_eece0e40dafb39c6.z, 2, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_46e7b1fb9f014b62, custom_c82ec2f59ceb854e));
  const highp float s16ab = 1.0;
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7((custom_eece0e40dafb39c6.y + s16ab), 2, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_46e7b1fb9f014b62, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7(custom_eece0e40dafb39c6.x, 4, custom_c82ec2f59ceb854e));
  (custom_dc3b6638b4b7cf50 = vec2(2.0, 14.0));
  (custom_ebff057bd64d779a = 1);
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_dca27d8cadefa787, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_7fa56cb12c591713, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_928d9e40d21f2dd4, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_8c32636550787def, custom_c82ec2f59ceb854e));
  (custom_ebff057bd64d779a = 0);
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_107cb01e133f919d, custom_c82ec2f59ceb854e));
  (custom_ebff057bd64d779a = 2);
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7(custom_77b6ff4fa4f14048, 2, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_107cb01e133f919d, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7(custom_d976b1da5776fe67, 2, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_107cb01e133f919d, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7(custom_8b0a5e20e6d5d1c8, 2, custom_c82ec2f59ceb854e));
  (custom_dc3b6638b4b7cf50 = vec2(2.0, 2.0));
  (custom_ebff057bd64d779a = 1);
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_a25a1289840af282, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_8c32636550787def, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_3af7b7d4ab96c0e, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_1a8a126282b27db9, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_a09e692c9aea15a5, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_befd9464d1662f38, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_43e44ce01f171d64, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_7fa56cb12c591713, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_1a8a126282b27db9, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_42a613670c3674b1, custom_c82ec2f59ceb854e));
  (custom_ebff057bd64d779a = 0);
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_107cb01e133f919d, custom_c82ec2f59ceb854e));
  (custom_ebff057bd64d779a = 2);
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7(custom_e914e45bb5c56267.x, 0, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_41d06a1f7c3b87d9(custom_8d38c3c8aac5a084, custom_c82ec2f59ceb854e));
  (custom_5a71a30409cd6bd6 += custom_32186bc26d62d4d7(custom_e914e45bb5c56267.y, 0, custom_c82ec2f59ceb854e));
  return custom_5a71a30409cd6bd6;
}
void custom_f473b6d23ddb8775(out highp vec4 custom_e30b609a99317854, in highp vec2 custom_af11434e7e975b00){
  (custom_e30b609a99317854 = vec4(0.0, 0.0, 0.0, 0.0));
  const highp float s16ac = 3.0;
  (custom_3fbe9df714044829 = (custom_e914e45bb5c56267.xy / s16ac));
  const highp float s16ad = 3.0;
  highp vec2 custom_c82ec2f59ceb854e = (custom_af11434e7e975b00.xy / s16ad);
  const highp float s16ae = 3.0;
  highp vec2 custom_f03bd4ecac37830f = floor((custom_af11434e7e975b00.xy / s16ae));
  highp float custom_74129b9d5793af0e = custom_25b98a04c46d8d37(custom_f03bd4ecac37830f);
  highp vec2 custom_34913dac833f53c9 = (custom_af11434e7e975b00 / custom_e914e45bb5c56267.xy);
  const highp float s16af = 0.5;
  const highp float s16b0 = 0.5;
  const highp vec3 s16b1 = vec3(0.0, 2.0, 4.0);
  highp vec3 custom_5e476c4bb78d3b4b = (s16af + (s16b0 * cos(((custom_905c3f97a4912a69 + custom_34913dac833f53c9.xyx) + s16b1))));
  highp vec3 custom_5a71a30409cd6bd6 = vec3(1.0, 1.0, 1.0);
  const highp float s16b2 = 1.0;
  const highp float s16b3 = 1.2;
  (custom_5a71a30409cd6bd6 *= ((s16b2 - distance(mod(custom_c82ec2f59ceb854e, vec2(1.0, 1.0)), vec2(0.64999998, 0.64999998))) * s16b3));
  (custom_5a71a30409cd6bd6 *= mix(vec3(0.2, 0.2, 0.2), custom_5e476c4bb78d3b4b, custom_74129b9d5793af0e));
  const highp float s16b4 = 1.0;
  (custom_e30b609a99317854 = vec4(vec3(custom_5a71a30409cd6bd6), s16b4));
}`;

const snoop_duck_frac_rope_frag = `#version 300 es
uniform highp vec3 custom_e914e45bb5c56267;
uniform highp float custom_905c3f97a4912a69;
uniform highp float custom_70423549a8529160[4];
uniform highp vec4 custom_1f66b3243e102e24;
uniform highp vec4 custom_eece0e40dafb39c6;
uniform highp float custom_77756f64d745704e;
uniform highp vec3 custom_c2308a19d7a17a82[4];
uniform highp int custom_2c04bf2ac4be0f31;
uniform highp float custom_851413965f0606e7;
uniform highp float custom_1c91913b763d547c;
uniform lowp samplerCube custom_ceb2d6eea8801718;
uniform struct {
  lowp samplerCube custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_6701f1729fb5bda4;
uniform lowp sampler2D custom_167041ad3f01be39;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_cebd318f3528d25a;
uniform lowp sampler2D custom_43ccb34651cbffe8;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_b6662b624451f6aa;
uniform lowp sampler2D custom_7fbae08bfdefee49;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_9cd5d8f2ade25989;
void custom_f473b6d23ddb8775(out highp vec4 custom_e30b609a99317854, in highp vec2 custom_af11434e7e975b00);
out highp vec4 custom_3e7e5c94b10cd58f;
void main(){
  (custom_3e7e5c94b10cd58f = vec4(0.0, 0.0, 0.0, 0.0));
  (custom_3e7e5c94b10cd58f = vec4(1.0, 1.0, 1.0, 1.0));
  highp vec4 custom_54d478077cd5722c = vec4(100000002004087734272.0, 100000002004087734272.0, 100000002004087734272.0, 100000002004087734272.0);
  custom_f473b6d23ddb8775(custom_54d478077cd5722c, gl_FragCoord.xy);
  if ((custom_3e7e5c94b10cd58f.x < 0.0))
  {
    (custom_54d478077cd5722c = vec4(1.0, 0.0, 0.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.y < 0.0))
  {
    (custom_54d478077cd5722c = vec4(0.0, 1.0, 0.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.z < 0.0))
  {
    (custom_54d478077cd5722c = vec4(0.0, 0.0, 1.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.w < 0.0))
  {
    (custom_54d478077cd5722c = vec4(1.0, 1.0, 0.0, 1.0));
  }
  const highp float s1658 = 1.0;
  (custom_3e7e5c94b10cd58f = vec4(custom_54d478077cd5722c.xyz, s1658));
}
highp vec3 custom_bed3ddc8f1b9be14(in highp float custom_138cc122551b2816, in highp vec3 custom_5556b01ba794933c, in highp vec3 custom_7bcad206d9cd79a4, in highp vec3 custom_b4a0c1ca0ea7ec32, in highp vec3 custom_fa6ee8ecaada3b41){
  const highp float s1659 = 6.2831802;
  return (custom_5556b01ba794933c + (custom_7bcad206d9cd79a4 * cos((s1659 * ((custom_b4a0c1ca0ea7ec32 * custom_138cc122551b2816) + custom_fa6ee8ecaada3b41)))));
}
highp mat2 custom_2c2b6c45e50e0e7c(in highp float custom_5556b01ba794933c){
  highp float custom_c56de7baf5e2ca91 = sin(custom_5556b01ba794933c);
  highp float custom_b4a0c1ca0ea7ec32 = cos(custom_5556b01ba794933c);
  return mat2(custom_b4a0c1ca0ea7ec32, (-custom_c56de7baf5e2ca91), custom_c56de7baf5e2ca91, custom_b4a0c1ca0ea7ec32);
}
highp float custom_ee33389d489f04a5(in highp vec3 custom_8eb5d4990284390f){
  highp vec2 custom_c82ec2f59ceb854e = custom_8eb5d4990284390f.xz;
  (custom_c82ec2f59ceb854e.x = abs(custom_c82ec2f59ceb854e.x));
  const highp float s165a = 12.0;
  highp float custom_b4e26d1ba0db9b6e = (s165a + custom_905c3f97a4912a69);
  highp vec2 custom_373240156d8fca68 = vec2(1.0, 0.0);
  const highp float s165b = 0.40000001;
  const highp float s165c = 0.60000002;
  highp float custom_6a8fc7cb14ef147b = ((s165b * custom_8eb5d4990284390f.y) - (s165c * custom_b4e26d1ba0db9b6e));
  highp float custom_f9ace9bd2f6f65c5 = 9.0;
  const highp float s165d = -0.0;
  const highp float s165e = 1.8;
  highp float custom_d23c3614f42bebfd = ((s165d * length(custom_c82ec2f59ceb854e)) + s165e);
  for (highp float custom_441e866d43abd7e9 = 0.0; (custom_441e866d43abd7e9 < custom_f9ace9bd2f6f65c5); (custom_441e866d43abd7e9++))
  {
    (custom_c82ec2f59ceb854e -= (custom_d23c3614f42bebfd * custom_373240156d8fca68));
    const highp float s165f = 0.5;
    const highp float s1660 = 0.050000001;
    (custom_6a8fc7cb14ef147b += ((s165f * custom_8eb5d4990284390f.y) + (s1660 * custom_b4e26d1ba0db9b6e)));
    (custom_c82ec2f59ceb854e = (custom_2c2b6c45e50e0e7c(custom_6a8fc7cb14ef147b) * custom_c82ec2f59ceb854e));
    (custom_c82ec2f59ceb854e.x = abs(custom_c82ec2f59ceb854e.x));
    const highp float s1661 = 0.050000001;
    const highp float s1662 = 8.0;
    const highp float s1663 = 0.55000001;
    (custom_d23c3614f42bebfd *= ((s1661 * cos((s1662 * length(custom_c82ec2f59ceb854e)))) + s1663));
  }
  const highp float s1664 = 2.0;
  highp float custom_fa6ee8ecaada3b41 = (length(custom_c82ec2f59ceb854e) - (s1664 * custom_d23c3614f42bebfd));
  const highp float s1665 = 0.5;
  return (s1665 * custom_fa6ee8ecaada3b41);
}
highp float custom_a4c438baa6b5ee48(in highp vec3 custom_3a08dc3ca47ea9d3, in highp vec3 custom_6f531b3ab0bf395d){
  highp float custom_42d1d46d83689183 = 0.0;
  for (highp int custom_441e866d43abd7e9 = 0; (custom_441e866d43abd7e9 < 400); (custom_441e866d43abd7e9++))
  {
    highp vec3 custom_8eb5d4990284390f = (custom_3a08dc3ca47ea9d3 + (custom_6f531b3ab0bf395d * custom_42d1d46d83689183));
    highp float custom_bdaa61582420e4b = custom_ee33389d489f04a5(custom_8eb5d4990284390f);
    (custom_42d1d46d83689183 += custom_bdaa61582420e4b);
    if (((custom_42d1d46d83689183 > 10.0) || (abs(custom_bdaa61582420e4b) < 0.001)))
    {
      break;
    }
  }
  return custom_42d1d46d83689183;
}
highp vec3 custom_531503d294c63da(in highp vec3 custom_8eb5d4990284390f){
  highp float custom_fa6ee8ecaada3b41 = custom_ee33389d489f04a5(custom_8eb5d4990284390f);
  highp vec2 custom_b0e801079af5bb56 = vec2(0.001, 0.0);
  highp vec3 custom_f9ace9bd2f6f65c5 = (custom_fa6ee8ecaada3b41 - vec3(custom_ee33389d489f04a5((custom_8eb5d4990284390f - custom_b0e801079af5bb56.xyy)), custom_ee33389d489f04a5((custom_8eb5d4990284390f - custom_b0e801079af5bb56.yxy)), custom_ee33389d489f04a5((custom_8eb5d4990284390f - custom_b0e801079af5bb56.yyx))));
  return normalize(custom_f9ace9bd2f6f65c5);
}
highp vec3 custom_67c91c8c6686a56b(in highp vec2 custom_c82ec2f59ceb854e, in highp vec3 custom_8eb5d4990284390f, in highp vec3 custom_c68795569f6cf0aa, in highp float custom_5e92ca9401546dfa){
  highp vec3 custom_6aa4bd0f81a00055 = normalize((custom_c68795569f6cf0aa - custom_8eb5d4990284390f));
  highp vec3 custom_464d3b1340320851 = normalize(cross(vec3(0.0, 1.0, 0.0), custom_6aa4bd0f81a00055));
  highp vec3 custom_45b25958224c3773 = cross(custom_6aa4bd0f81a00055, custom_464d3b1340320851);
  highp vec3 custom_b4a0c1ca0ea7ec32 = (custom_6aa4bd0f81a00055 * custom_5e92ca9401546dfa);
  highp vec3 custom_441e866d43abd7e9 = ((custom_b4a0c1ca0ea7ec32 + (custom_c82ec2f59ceb854e.x * custom_464d3b1340320851)) + (custom_c82ec2f59ceb854e.y * custom_45b25958224c3773));
  highp vec3 custom_fa6ee8ecaada3b41 = normalize(custom_441e866d43abd7e9);
  return custom_fa6ee8ecaada3b41;
}
void custom_f473b6d23ddb8775(out highp vec4 custom_e30b609a99317854, in highp vec2 custom_af11434e7e975b00){
  (custom_e30b609a99317854 = vec4(0.0, 0.0, 0.0, 0.0));
  const highp float s1666 = 0.5;
  highp vec2 custom_c82ec2f59ceb854e = ((custom_af11434e7e975b00 - (s1666 * custom_e914e45bb5c56267.xy)) / custom_e914e45bb5c56267.y);
  highp float custom_464d3b1340320851 = 5.5;
  const highp float s1667 = 0.0;
  highp float custom_b4e26d1ba0db9b6e = (s1667 * custom_905c3f97a4912a69);
  const highp float s1668 = 0.1;
  highp vec3 custom_3a08dc3ca47ea9d3 = vec3((custom_464d3b1340320851 * cos(custom_b4e26d1ba0db9b6e)), (s1668 * custom_905c3f97a4912a69), (custom_464d3b1340320851 * sin(custom_b4e26d1ba0db9b6e)));
  const highp int s1669 = 0;
  const highp float s166a = 0.1;
  const highp int s166b = 0;
  highp vec3 custom_6f531b3ab0bf395d = custom_67c91c8c6686a56b(custom_c82ec2f59ceb854e, custom_3a08dc3ca47ea9d3, vec3(s1669, (s166a * custom_905c3f97a4912a69), s166b), 2.0);
  highp vec3 custom_5a71a30409cd6bd6 = vec3(0.0, 0.0, 0.0);
  highp float custom_fa6ee8ecaada3b41 = custom_a4c438baa6b5ee48(custom_3a08dc3ca47ea9d3, custom_6f531b3ab0bf395d);
  if ((custom_fa6ee8ecaada3b41 < 10.0))
  {
    highp vec3 custom_8eb5d4990284390f = (custom_3a08dc3ca47ea9d3 + (custom_6f531b3ab0bf395d * custom_fa6ee8ecaada3b41));
    highp vec3 custom_f9ace9bd2f6f65c5 = custom_531503d294c63da(custom_8eb5d4990284390f);
    highp vec3 custom_464d3b1340320851 = reflect(custom_6f531b3ab0bf395d, custom_f9ace9bd2f6f65c5);
    highp float custom_f3f5df220296429b = 0.30000001;
    highp float custom_aa012c3d995f28e8 = 0.40000001;
    highp float custom_6a5681a93eb9bc8f = max(dot(custom_f9ace9bd2f6f65c5, vec3(0.26726124, 0.53452247, 0.80178368)), 0.0);
    (custom_5a71a30409cd6bd6 = vec3(((custom_6a5681a93eb9bc8f * custom_aa012c3d995f28e8) + custom_f3f5df220296429b)));
    const highp float s166c = 1.0;
    (custom_5a71a30409cd6bd6 *= (s166c + custom_464d3b1340320851.y));
    (custom_5a71a30409cd6bd6 = clamp(custom_5a71a30409cd6bd6, 0.0, 1.0));
    highp vec3 custom_b0e801079af5bb56 = vec3(1.0, 1.0, 1.0);
    (custom_5a71a30409cd6bd6 *= custom_bed3ddc8f1b9be14(custom_464d3b1340320851.y, custom_b0e801079af5bb56, custom_b0e801079af5bb56, custom_b0e801079af5bb56, vec3(0.0, 0.1155, 0.23100001)));
  }
  (custom_5a71a30409cd6bd6 = pow(custom_5a71a30409cd6bd6, vec3(0.45449999, 0.45449999, 0.45449999)));
  const highp float s166d = 1.0;
  (custom_e30b609a99317854 = vec4(custom_5a71a30409cd6bd6, s166d));
}`;

const fog_dither_frag = `#version 300 es
void initGlobals();
uniform highp vec3 custom_e914e45bb5c56267;
uniform highp float custom_905c3f97a4912a69;
uniform highp float custom_70423549a8529160[4];
uniform highp vec4 custom_1f66b3243e102e24;
uniform highp vec4 custom_eece0e40dafb39c6;
uniform highp float custom_77756f64d745704e;
uniform highp vec3 custom_c2308a19d7a17a82[4];
uniform highp int custom_2c04bf2ac4be0f31;
uniform highp float custom_851413965f0606e7;
uniform highp float custom_1c91913b763d547c;
uniform lowp sampler2D custom_ceb2d6eea8801718;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_6701f1729fb5bda4;
uniform lowp sampler2D custom_167041ad3f01be39;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_cebd318f3528d25a;
uniform lowp sampler2D custom_43ccb34651cbffe8;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_b6662b624451f6aa;
uniform lowp sampler2D custom_7fbae08bfdefee49;
uniform struct {
  lowp sampler2D custom_52da786e198279ca;
  highp vec3 custom_8f50b876e5f5c0a1;
  highp float custom_b4e26d1ba0db9b6e;
  highp int custom_e7e12684e5270f30;
} custom_9cd5d8f2ade25989;
void custom_f473b6d23ddb8775(out mediump vec4 custom_e30b609a99317854, in mediump vec2 custom_af11434e7e975b00);
out highp vec4 custom_3e7e5c94b10cd58f;
void main(){
  initGlobals();
  (custom_3e7e5c94b10cd58f = vec4(0.0, 0.0, 0.0, 0.0));
  (custom_3e7e5c94b10cd58f = vec4(1.0, 1.0, 1.0, 1.0));
  highp vec4 custom_54d478077cd5722c = vec4(100000002004087734272.0, 100000002004087734272.0, 100000002004087734272.0, 100000002004087734272.0);
  custom_f473b6d23ddb8775(custom_54d478077cd5722c, gl_FragCoord.xy);
  if ((custom_3e7e5c94b10cd58f.x < 0.0))
  {
    (custom_54d478077cd5722c = vec4(1.0, 0.0, 0.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.y < 0.0))
  {
    (custom_54d478077cd5722c = vec4(0.0, 1.0, 0.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.z < 0.0))
  {
    (custom_54d478077cd5722c = vec4(0.0, 0.0, 1.0, 1.0));
  }
  if ((custom_3e7e5c94b10cd58f.w < 0.0))
  {
    (custom_54d478077cd5722c = vec4(1.0, 1.0, 0.0, 1.0));
  }
  const highp float s1639 = 1.0;
  (custom_3e7e5c94b10cd58f = vec4(custom_54d478077cd5722c.xyz, s1639));
}
mediump vec3 custom_4841983370eefe5e[16];
mediump vec3 custom_1a02c4766b1f7fb2[6];
void custom_db8859f834fc29c5(){
  (custom_4841983370eefe5e[0] = vec3(0.078431375, 0.078431375, 0.1254902));
  (custom_4841983370eefe5e[1] = vec3(0.14901961, 0.14901961, 0.28627452));
  (custom_4841983370eefe5e[2] = vec3(0.2, 0.2, 0.36862746));
  (custom_4841983370eefe5e[3] = vec3(0.24705882, 0.24705882, 0.45490196));
  (custom_4841983370eefe5e[4] = vec3(0.32941177, 0.32941177, 0.59607846));
  (custom_4841983370eefe5e[5] = vec3(0.54509807, 0.47450981, 0.51372552));
  (custom_4841983370eefe5e[6] = vec3(0.64705884, 0.5529412, 0.53725493));
  (custom_4841983370eefe5e[7] = vec3(0.70980394, 0.61960787, 0.56470591));
  (custom_1a02c4766b1f7fb2[0] = custom_4841983370eefe5e[0]);
  (custom_1a02c4766b1f7fb2[1] = custom_4841983370eefe5e[1]);
  (custom_1a02c4766b1f7fb2[2] = custom_4841983370eefe5e[2]);
  (custom_1a02c4766b1f7fb2[3] = custom_4841983370eefe5e[3]);
  (custom_1a02c4766b1f7fb2[4] = custom_4841983370eefe5e[4]);
  (custom_1a02c4766b1f7fb2[5] = custom_4841983370eefe5e[5]);
}
mediump vec3 custom_eabee94af12f0a24(in mediump float custom_350702f5a0424893, in mediump vec2 custom_74129b9d5793af0e){
  const mediump float s163a = 5.0;
  mediump float custom_21448f8bb07bcdb5 = (clamp(custom_350702f5a0424893, 0.0, 1.0) * s163a);
  mediump vec3 custom_b89cc79bcb9569ed = vec3(0.0, 0.0, 0.0);
  mediump vec3 custom_c649457111b12768 = vec3(0.0, 0.0, 0.0);
  for (highp int custom_441e866d43abd7e9 = 0; (custom_441e866d43abd7e9 < 6); (custom_441e866d43abd7e9++))
  {
    if ((float(custom_441e866d43abd7e9) == floor(custom_21448f8bb07bcdb5)))
    {
      const highp float s163b = 0.0;
      const highp float s163c = 5.0;
      (custom_b89cc79bcb9569ed = custom_1a02c4766b1f7fb2[int(clamp(float(custom_441e866d43abd7e9), s163b, s163c))]);
      const highp int s163d = 1;
      const highp float s163e = 0.0;
      const highp float s163f = 5.0;
      (custom_c649457111b12768 = custom_1a02c4766b1f7fb2[int(clamp(float((custom_441e866d43abd7e9 + s163d)), s163e, s163f))]);
      break;
    }
  }
  mediump float custom_3426241d0c7e0db8 = texture(custom_ceb2d6eea8801718, (custom_74129b9d5793af0e / custom_c2308a19d7a17a82[0].xy)).x;
  mediump float custom_533a89ff1f162e61 = float((fract(custom_21448f8bb07bcdb5) > custom_3426241d0c7e0db8));
  return mix(custom_b89cc79bcb9569ed, custom_c649457111b12768, custom_533a89ff1f162e61);
}
mediump vec2 custom_52fbd95fca0fbae9(in mediump vec2 custom_5d605553abaff0a3){
  (custom_5d605553abaff0a3 = vec2(dot(custom_5d605553abaff0a3, vec2(127.1, 311.70001)), dot(custom_5d605553abaff0a3, vec2(269.5, 183.3))));
  const mediump float s1640 = -1.0;
  const mediump float s1641 = 2.0;
  const mediump float s1642 = 7.0;
  return (s1640 + (s1641 * fract((sin(custom_5d605553abaff0a3) * s1642))));
}
mediump float custom_c2a2237d4ce4d32a(in mediump vec2 custom_5d605553abaff0a3){
  mediump vec2 custom_441e866d43abd7e9 = floor(custom_5d605553abaff0a3);
  mediump vec2 custom_6aa4bd0f81a00055 = fract(custom_5d605553abaff0a3);
  const mediump float s1643 = 3.0;
  const mediump float s1644 = 2.0;
  mediump vec2 custom_45b25958224c3773 = ((custom_6aa4bd0f81a00055 * custom_6aa4bd0f81a00055) * (s1643 - (s1644 * custom_6aa4bd0f81a00055)));
  const mediump vec2 s1645 = vec2(0.0, 0.0);
  const mediump vec2 s1646 = vec2(0.0, 0.0);
  const mediump vec2 s1647 = vec2(1.0, 0.0);
  const mediump vec2 s1648 = vec2(1.0, 0.0);
  const mediump vec2 s1649 = vec2(0.0, 1.0);
  const mediump vec2 s164a = vec2(0.0, 1.0);
  const mediump vec2 s164b = vec2(1.0, 1.0);
  const mediump vec2 s164c = vec2(1.0, 1.0);
  return mix(mix(dot(custom_52fbd95fca0fbae9((custom_441e866d43abd7e9 + s1645)), (custom_6aa4bd0f81a00055 - s1646)), dot(custom_52fbd95fca0fbae9((custom_441e866d43abd7e9 + s1647)), (custom_6aa4bd0f81a00055 - s1648)), custom_45b25958224c3773.x), mix(dot(custom_52fbd95fca0fbae9((custom_441e866d43abd7e9 + s1649)), (custom_6aa4bd0f81a00055 - s164a)), dot(custom_52fbd95fca0fbae9((custom_441e866d43abd7e9 + s164b)), (custom_6aa4bd0f81a00055 - s164c)), custom_45b25958224c3773.x), custom_45b25958224c3773.y);
}
mediump float custom_1ea01310d0a430de(in mediump vec2 custom_8c2e2ebfa56eafb9){
  mediump float custom_add5414df880507d = 0.0;
  mediump float custom_f55250475f89149f = 0.2;
  for (highp int custom_441e866d43abd7e9 = 0; (custom_441e866d43abd7e9 < 4); (custom_441e866d43abd7e9++))
  {
    (custom_add5414df880507d += (custom_c2a2237d4ce4d32a(custom_8c2e2ebfa56eafb9) * custom_f55250475f89149f));
    const mediump float s164d = 2.0;
    (custom_8c2e2ebfa56eafb9 *= s164d);
    const mediump float s164e = 0.5;
    (custom_f55250475f89149f *= s164e);
  }
  const mediump float s164f = 0.2;
  return (custom_add5414df880507d + s164f);
}
void custom_f473b6d23ddb8775(out mediump vec4 custom_e30b609a99317854, in mediump vec2 custom_af11434e7e975b00){
  (custom_e30b609a99317854 = vec4(0.0, 0.0, 0.0, 0.0));
  custom_db8859f834fc29c5();
  mediump vec2 custom_5d605553abaff0a3 = (custom_af11434e7e975b00.xy / custom_e914e45bb5c56267.xy);
  (custom_5d605553abaff0a3 *= (custom_e914e45bb5c56267.xy / custom_e914e45bb5c56267.y));
  const mediump float s1650 = 3.0;
  const highp float s1651 = 0.1;
  mediump vec2 custom_b3d175d1a4203aee = vec2(((custom_5d605553abaff0a3 * s1650) + (custom_905c3f97a4912a69 * s1651)));
  const highp float s1652 = 0.40000001;
  const highp float s1653 = -0.2;
  mediump vec2 custom_bac312760259c598 = vec2(custom_1ea01310d0a430de((custom_b3d175d1a4203aee + vec2((custom_905c3f97a4912a69 * s1652), (custom_905c3f97a4912a69 * s1653)))));
  const mediump float s1654 = 2.0;
  mediump float custom_74e9518a675d9b09 = (custom_1ea01310d0a430de((custom_b3d175d1a4203aee + custom_bac312760259c598)) * s1654);
  const mediump float s1655 = 1.0;
  mediump vec3 custom_54d478077cd5722c = custom_eabee94af12f0a24(custom_74e9518a675d9b09, (custom_af11434e7e975b00 / s1655));
  const mediump float s1656 = 1.0;
  (custom_e30b609a99317854 = vec4(custom_54d478077cd5722c, s1656));
}
void initGlobals(){
  const highp int s1657 = 16;
  for (highp int s1636 = 0; (s1636 < s1657); (++s1636))
  {
    (custom_4841983370eefe5e[s1636] = vec3(0.0, 0.0, 0.0));
  }
  const highp int s1658 = 6;
  for (highp int s1637 = 0; (s1637 < s1658); (++s1637))
  {
    (custom_1a02c4766b1f7fb2[s1637] = vec3(0.0, 0.0, 0.0));
  }
}`;